window.addEventListener('load', function () {
    let waitUntilElementVisible = function (selector, callback) {
        if (jQuery(selector).is(':visible')) {
            callback();
        } else {
            setTimeout(function () {
                waitUntilElementVisible(selector, callback);
            }, 25);
        }
    };

    (function ($) {
        'use strict';

        let bounds, map, htmlMapId, mapData, $map, url, polygon, mapOptions, $errorModal = $('#error-modal');

        $.each($('.mapq-map'), function (_, map) {
            waitUntilElementVisible(map, function () {
                $map = $(map);
                htmlMapId = $map.prop('id');
                mapData = mapq_maps[$map.data('mapId')];

                mapOptions = {
                    minZoom: mapData.min_zoom || 0,
                    zoom: mapData.min_zoom || 7,
                    maxZoom: mapData.max_zoom || 18,
                    center: [mapData.center.lat, mapData.center.lng],
                };

                if (mapData.zoomable === false) {
                    mapOptions.maxZoom = mapOptions.minZoom;
                }

                map = L.map(htmlMapId, mapOptions);
                mapq_maps[htmlMapId] = map;
                // Open Leaflet page in new window
                map.attributionControl.setPrefix('<a target="_blank" href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>');

                if (mapData.source_type === 'osm') { // OpenStreetMap
                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; <a target="_blank" href="https://openstreetmap.org/copyright">OpenStreetMap</a>'
                    }).addTo(map);

                    L.control.scale().addTo(map);
                } else if (mapData.source_type === 'image') { // Image
                    if (!mapData.image_attachment || typeof mapData.image_attachment[0] === "undefined" || mapData.image_attachment[0] === "") {
                        return console.error("Image attachment source not available");
                    }
                    url = mapData.image_attachment[0];

                    bounds = new L.LatLngBounds(
                        mapData.bounds.south_west,
                        mapData.bounds.north_east
                    );

                    L.imageOverlay(url, bounds).addTo(map);
                    map.fitBounds(bounds);
                    map.options.maxBoundsViscosity = 1.0;
                    map.options.maxBounds = bounds;
                }
                map.on('click', addMarker);

                if (mapData.info_layers && mapData.info_layers.length !== 0) {
                    let infoLayer = L.geoJSON(null, {
                        style: function (featureObject) {
                            return {
                                color: mapData.info_layers_color,
                                weight: 0,
                                fillOpacity: mapData.info_layers_opacity
                            };
                        }
                    }).addTo(map);
                    infoLayer.addData(mapData.info_layers);
                }

                if (mapData.layers && mapData.layers.length !== 0) {
                    let borderLayer = L.geoJSON(null, {
                        style: function (featureObject) {
                            return {
                                color: mapData.layers_color,
                                weight: mapData.layers_weight,
                                opacity: mapData.layers_opacity,
                                fill: true,
                                fillOpacity: mapData.layers_fill_opacity
                            };
                        }
                    }).addTo(map);
                    borderLayer.addData(mapData.layers);

                    map.invalidateSize();
                    map.fitBounds(borderLayer.getBounds());
                }

                let $body = $('body');
                let $submitModal = $('[data-html-map-id="' + htmlMapId + '"].submit-modal');
                let $viewModal = $('[data-html-map-id="' + htmlMapId + '"].view-modal');

                // Move the modals outside main content div
                $body.append($submitModal);
                $body.append($viewModal);

                $submitModal.find('.form-tag-placeholder').replaceWith('<form>' + $submitModal.find('.form-tag-placeholder').html() + '</form>');
                $viewModal.find('.form-tag-placeholder').replaceWith('<form>' + $viewModal.find('.form-tag-placeholder').html() + '</form>');

                $submitModal.on('show.bs.modal', function (e) {
                    handleSubmitModalOpen($(this));
                })

                $submitModal.on('hide.bs.modal', function (e) {
                    let marker = $submitModal.data('marker');
                    if (marker.mqFormData && typeof marker.mqFormData.id === "undefined") {
                        // If close only without save, remove the marker
                        map.removeLayer(marker);
                    }
                    $submitModal.data('marker', null);
                })

                $submitModal.on('submit', 'form', function (e) {
                    e.preventDefault();
                    let $button;
                    if (e.originalEvent) {
                        $button = $(e.originalEvent.submitter);
                        $button.prop('disabled', true);
                    }
                    let marker = $submitModal.data('marker');

                    let formData = $submitModal.find('form').serializeArray();
                    formData.push({name: 'action', value: 'save_questionnaire_marker'});

                    if (mapData.comment_required && objectifyForm(formData).comment === '') {
                        if ($button) {
                            $button.prop('disabled', false);
                        }
                        $errorModal.css('z-index', '9999');
                        return $errorModal.find('[data-name="error_message"]').html(mapqJsVars.i18n.commentIsRequired) && $errorModal.modal('show');
                    }

                    $.ajax({
                        type: "POST",
                        url: mapqJsVars.ajaxUrl,
                        data: formData,
                        dataType: "json",
                        success: function (data) {
                        },
                        error: function (data) {
                            console.error(data);
                        }
                    }).then(function (data, textStatus, jqXHR) {
                        if ($button) {
                            $button.prop('disabled', false);
                        }
                        marker.mqFormData = objectifyForm(formData);
                        marker.mqFormData.editable = true;
                        marker.mqFormData.id = data.data.id;
                        marker.mqFormData.session_id = mapq_session_id;
                        marker.setIcon(mapData.markerIcons[parseInt(marker.mqFormData.marker_type_id)]);
                        $submitModal.modal('hide');

                        // If we are in eForm, populate the field with previously set markers
                        updateEFormInput(map);
                    });
                });

                $submitModal.on('click', '.btn.remove-marker', function (e) {
                    let $button = $(e.originalEvent.target);
                    $button.prop('disabled', true);
                    let marker = $submitModal.data('marker');

                    if (!marker.mqFormData.id) {
                        map.removeLayer(marker);
                        $button.prop('disabled', false);
                        return $submitModal.modal('hide');
                    }

                    let formData = $submitModal.find('form').serializeArray();
                    formData.push({name: 'action', value: 'remove_questionnaire_marker'});

                    $.ajax({
                        type: "POST",
                        url: mapqJsVars.ajaxUrl,
                        data: formData,
                        dataType: "json",
                        success: function (data) {
                            map.removeLayer(marker);
                        },
                        error: function (data) {
                            console.error(data);
                        }
                    }).then(function (data, textStatus, jqXHR) {
                        $button.prop('disabled', false);
                        $submitModal.modal('hide');

                        // If we are in eForm, populate the field with previously set markers
                        updateEFormInput(map);
                    });
                })

                $viewModal.on('show.bs.modal', function (e) {
                    let marker = $viewModal.data('marker');

                    if (marker.mqFormData) {
                        if (marker.mqFormData.editable) {
                            // Opened this by error, this should be submit modal
                            return;
                        }

                        // Prefill modal data with previous values
                        $.each(marker.mqFormData, function (name, value) {
                            $viewModal.find('[data-name="' + name + '"]').html(value);
                        })
                    }
                })

                $errorModal.on('hide.bs.modal', function (e) {
                    $errorModal.find('[data-name="error_message"]').html('');
                });

                //Caching marker icons elements
                mapData.markerIcons = [];
                $.each(mapData.marker_types, function (_, markerType) {
                    if (!markerType.image_attachment) {
                        return;
                    }
                    mapData.markerIcons[markerType.id] = L.icon({
                        iconUrl: markerType.image_attachment[0],
                        iconSize: [markerType.image_attachment[1], markerType.image_attachment[2]],
                        // iconAnchor: [0,0],
                        iconAnchor: [(markerType.image_attachment[1] / 2), markerType.image_attachment[2]], // width/2, height
                        mType: markerType.type
                    });
                })

                // Load previously set markers
                if (mapData.markers && mapData.markers.length !== 0) {
                    $.each(mapData.markers, function (_, markerData) {
                        let marker = L.marker(new L.LatLng(markerData.lat, markerData.lng), {
                            icon: mapData.markerIcons[markerData.marker_type_id],
                            draggable: markerData.editable,
                            preferCanvas: true
                        }).addTo(map);

                        marker.mqFormData = markerData;
                        marker.on('click', handleMarkerClick);
                        marker.on('dragend', handleMarkerDrag);
                        marker.on('dragstart', function () {
                            map.off('click');
                        });
                    })
                }

                // If we are in eForm, populate the field with previously set markers
                updateEFormInput(map);

                let $markerControls = $('[data-html-map-id="' + htmlMapId + '"].marker-controls');
                // Init left side draggable markers

                $markerControls.find('.marker-draggable').draggable({
                    helper: 'clone',
                    containment: 'map',
                    start: function (evt, ui) {
                        ui.helper.css('height', $(this).css('height')).css('width', $(this).css('width'));
                    },
                    stop: function (evt, ui) {
                        let markerIcon = mapData.markerIcons[parseInt($(evt.target).data('typeId'))],
                            mapOffset = $map.offset(),
                            coordsX = ui.offset.left - mapOffset.left + markerIcon.options.iconAnchor[0],
                            coordsY = ui.offset.top - mapOffset.top + markerIcon.options.iconAnchor[1],// 40 is the height of the marker
                            point = L.point(coordsX, coordsY), // creating a Point object with the given x and y coordinates
                            markerCoords = map.containerPointToLatLng(point); // getting the geographical coordinates of the point

                        addMarker.apply(map, [{
                            latlng: markerCoords,
                            markerIcon: markerIcon
                        }]);
                    },
                });
            });
        })

        function updateEFormInput(map) {
            let $eFormInput = $('[data-mapq-id="' + map.getContainer().dataset.mapId + '"]');
            if ($eFormInput.length) {
                let markerIds = [];
                map.eachLayer(function (layer) {
                    if (layer instanceof L.Marker) {
                        if (layer.mqFormData && layer.mqFormData.id &&
                            (typeof layer.mqFormData.form_submission_id === "undefined" || layer.mqFormData.form_submission_id === '' || layer.mqFormData.form_submission_id === null) &&
                            (typeof layer.mqFormData.form_submission_id !== "undefined" && layer.mqFormData.form_submission_id !== '') &&
                            layer.mqFormData.editable) {
                            markerIds.push(layer.mqFormData.id);
                        }
                    }
                });
                if (markerIds.length === 0) {
                    $eFormInput.val('');
                } else {
                    $eFormInput.val(JSON.stringify(markerIds));
                }
            }
        }

        function handleSubmitModalOpen($submitModal) {
            let $form = $submitModal.find('form');
            $form.trigger('reset');
            $form.find('[name="id"], [name="lat"], [name="lng"]').val('');

            let marker = $submitModal.data('marker');

            if (marker.mqFormData) {
                if (!marker.mqFormData.editable) {
                    // Opened this by error
                    return;
                }


                let excludeFields = '';
                // First render the correct inputs
                if (marker.mqFormData.type === 'dropdown') {
                    excludeFields = '.freetext-fields';
                    $submitModal.find('.freetext-fields').hide();
                    $submitModal.find('.freetext-fields input, .freetext-fields select').each(function (_, el) {
                        $(el).prop('disabled', true);
                    })
                    $submitModal.find('.dropdown-fields').show();
                    $submitModal.find('.dropdown-fields input, .dropdown-fields select').each(function (_, el) {
                        $(el).prop('disabled', false);
                    });

                    let markerType = mapData.marker_types.find(
                        function (marker_type) {
                            return parseInt(marker_type.id) === parseInt(marker.mqFormData.marker_type_id);
                        });
                    if (typeof markerType !== "undefined" && markerType !== null && markerType.options.length > 0) {
                        let $optionSelect = $submitModal.find('.dropdown-fields select').empty();
                        $('<option/>')
                            .val('')
                            .text(markerType.label)
                            .appendTo($optionSelect)
                        $.each(markerType.options, function (_, option) {
                            $('<option/>')
                                .val(option)
                                .text(option)
                                .appendTo($optionSelect)
                        })
                    }
                } else {
                    excludeFields = '.dropdown-fields';
                    $submitModal.find('.freetext-fields').show();
                    $submitModal.find('.freetext-fields input, .freetext-fields select').each(function (_, el) {
                        $(el).prop('disabled', false);
                    });
                    $submitModal.find('.dropdown-fields').hide();
                    $submitModal.find('.dropdown-fields input, .dropdown-fields select').each(function (_, el) {
                        $(el).prop('disabled', true);
                    });
                }
                // Prefill modal data with previous values
                $.each(marker.mqFormData, function (name, value) {
                    let $input;
                    if (name === 'marker_type_id') {
                        $input = $form.find('.' + marker.mqFormData.type + '-fields [name=marker_type_id]');
                    } else {
                        $input = $form.find('[name="' + name + '"]');
                    }
                    if ($input.length && $input.get(0).type === "radio" && marker.mqFormData.type === 'freetext') {
                        $form.find('.' + marker.mqFormData.type + '-fields [name="' + name + '"][value="' + value + '"]').prop('checked', true);
                    } else if ($input.length) {
                        $input.val(value);
                    }
                })
            }

            if (typeof marker !== "undefined" && typeof marker.getLatLng() !== "undefined") {
                $form.find('[name="lat"]').val(marker.getLatLng().lat);
                $form.find('[name="lng"]').val(marker.getLatLng().lng);
            }
        }

        function handleMarkerDrag(e) {
            let htmlMapId = $(this._map.getContainer()).prop('id');
            let marker = e.target;
            let map = marker._map;

            if (!marker.mqFormData.editable) {
                marker.setLatLng([marker.mqFormData.lat, marker.mqFormData.lng]);
                return $errorModal.find('[data-name="error_message"]').html(mapqJsVars.i18n.nonEditable) && $errorModal.modal('show');
            }

            if (!isMarkerInsideMapPolygons(marker._latlng, map)) {
                marker.setLatLng([marker.mqFormData.lat, marker.mqFormData.lng]);
                return $errorModal.find('[data-name="error_message"]').html(mapqJsVars.i18n.notInPolygon) && $errorModal.modal('show');
            }
            marker.mqFormData.lat = marker._latlng.lat;
            marker.mqFormData.lng = marker._latlng.lng;

            let $modal = $('[data-html-map-id="' + htmlMapId + '"].submit-modal');
            $modal.data('marker', this);
            handleSubmitModalOpen($modal);
            $modal.find('form').submit();

            // Fix for overly sensitive dragend
            setTimeout(function () {
                map.on('click', addMarker);
            }, 1)
        }


        // Unbind map click on drag start

        function handleMarkerClick(e) {
            let htmlMapId = $(this._map.getContainer()).prop('id');
            let marker = this;
            let $modal;

            if (marker.mqFormData.editable) {
                $modal = $('[data-html-map-id="' + htmlMapId + '"].submit-modal');
            } else {
                // Opening other user's comment
                $modal = $('[data-html-map-id="' + htmlMapId + '"].view-modal');
            }

            $modal.data('marker', this);
            $modal.modal('show');
        }

        function objectifyForm(formArray) {
            //serialize data function
            var returnArray = {};
            for (var i = 0; i < formArray.length; i++) {
                returnArray[formArray[i]['name']] = formArray[i]['value'];
            }
            return returnArray;
        }

        function isMarkerInsideMapPolygons(latLng, map) {
            let insidePolygons = false;
            let numberOfPolygons = 0;
            // Check if the marker is inside of the polygons
            map.eachLayer(function (layer) {
                if (layer._layers) {
                    $.each(layer._layers, function (_, feature) {
                        if(feature instanceof L.Polygon){
                            numberOfPolygons++;
                            if (isMarkerInsideSinglePolygon(latLng, feature)) {
                                insidePolygons = true;
                            }
                        }
                    })
                }
            });

            return !(numberOfPolygons !== 0 && !insidePolygons);
        }

        function addMarker(e) {
            let map = this;
            let mapId = map.boxZoom._container.id;
            if (!isMarkerInsideMapPolygons(e.latlng, map)) {
                return $errorModal.find('[data-name="error_message"]').html(mapqJsVars.i18n.notInPolygon) && $errorModal.modal('show');
            }

            let numberOfUserMarkers = 0;
            map.eachLayer(function (layer) {
                if (layer instanceof L.Marker) {
                    if (layer.mqFormData && layer.mqFormData.editable) {
                        numberOfUserMarkers++;
                    }
                }
            });

            if (numberOfUserMarkers >= mapData.max_markers) {
                return $errorModal.find('[data-name="error_message"]').html(mapqJsVars.i18n.tooManyMarkers) && $errorModal.modal('show');
            }

            let defaultMarkerIcon = $.grep(mapData.markerIcons, function (e) {
                return e !== undefined && e.options.mType === 'freetext';
            })[0];
            if (typeof e.markerIcon !== "undefined") {
                defaultMarkerIcon = e.markerIcon;
            }
            if (typeof defaultMarkerIcon === "undefined") {
                return alert(mapqJsVars.i18n.useDragNDrop);
            }
            let marker = L.marker(e.latlng, {
                icon: defaultMarkerIcon,
                draggable: true
            }).addTo(map);
            marker.mqFormData = {
                marker_type_id: mapData.markerIcons.indexOf(defaultMarkerIcon),
                editable: true
            };
            let markerType = mapData.marker_types.find(
                function (marker_type) {
                    return parseInt(marker_type.id) === parseInt(marker.mqFormData.marker_type_id);
                });
            if (typeof markerType !== "undefined") {
                marker.mqFormData.type = markerType.type;
                marker.mqFormData.comment = $('.single-marker [data-type-id="' + marker.mqFormData.marker_type_id +'"]')
                    .first().parent('.single-marker.dropdown').find('select').val();
            }

            let $modal = $('[data-html-map-id="' + map.boxZoom._container.id + '"].submit-modal');

            marker.on('click', function (e) {
                $modal.data('marker', marker);
                $modal.modal('show');
            })

            $modal.data('marker', marker);
            if (marker.mqFormData.type && marker.mqFormData.type === 'dropdown') {
                handleSubmitModalOpen($modal);
                $modal.find('form').submit();
                updateEFormInput(map);
            } else {
                $modal.modal('show');
            }

            marker.on('dragend', handleMarkerDrag);
            marker.on('dragstart', function () {
                map.off('click');
            });
        }

        function isMarkerInsideSinglePolygon(latLng, poly) {
            var inside = false;
            var x = latLng.lat, y = latLng.lng;
            for (var ii = 0; ii < poly.getLatLngs().length; ii++) {
                var polyPoints = poly.getLatLngs()[ii];
                for (var i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
                    var xi = polyPoints[i].lat, yi = polyPoints[i].lng;
                    var xj = polyPoints[j].lat, yj = polyPoints[j].lng;

                    var intersect = ((yi > y) !== (yj > y))
                        && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
                    if (intersect) inside = !inside;
                }
            }

            return inside;
        }

        // function to search array using for loop
        function findInArray(ar, val) {
            for (var i = 0, len = ar.length; i < len; i++) {
                if (ar[i] === val) { // strict equality test
                    return i;
                }
            }
            return -1;
        }
    })(jQuery);
})